import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { approveChatConversationRequest, hideChatConversation } from '../../../actions/chat_conversations'
import { openModal } from '../../../actions/modal'
import { MODAL_CONFIRM } from '../../../constants'
import Text from '../../../components/text'
import { setChatConversationSelected } from '../../../actions/chats'

class ChatConversationRequestApproveBar extends React.PureComponent {  

  handleOnRejectMessageRequest = () => {
    const { dispatch, chatConversationId, history } = this.props
    dispatch(openModal(MODAL_CONFIRM, {
      title: 'Are you sure you want to reject this message request?',
      confirm: 'Yes, reject',
      onConfirm: () => {
        dispatch(hideChatConversation(chatConversationId))
        dispatch(setChatConversationSelected(null))
        history.push('/messages/requests')
      },
    }))
  }

  handleOnApproveMessageRequest = () => {
    const { dispatch, chatConversationId } = this.props
    dispatch(openModal(MODAL_CONFIRM, {
      title: 'Are you sure you want to approve this message request?',
      confirm: 'Yes, approve',
      onConfirm: () => {
        dispatch(approveChatConversationRequest(chatConversationId))
      },
    }))
  }

  setOptionsBtnRef = (c) => {
    this.optionsBtnRef = c
  }

  render () {
    const { chatConversationId, isXS } = this.props

    if (!chatConversationId) return null

    const btns = (
      <div className={[_s.d, _s.flexRow, _s.minH53PX, _s.w100PC].join(' ')}>
        <button
          className={[_s.d, _s.minH53PX, _s.aiCenter, _s.jcCenter, _s.flexGrow1, _s.bgDanger, _s.bgDangerDark_onHover, _s.outlineNone, _s.cursorPointer].join(' ')}
          onClick={this.handleOnRejectMessageRequest}
        >
          <Text color='white' align='center' weight='bold'>
            Reject
          </Text>
        </button>
        <button
          className={[_s.d, _s.minH53PX, _s.aiCenter, _s.jcCenter, _s.flexGrow1, _s.bgBrand, _s.bgBrandDark_onHover, _s.outlineNone, _s.cursorPointer].join(' ')}
          onClick={this.handleOnApproveMessageRequest}
        >
          <Text color='white' align='center' weight='bold'>
            Approve
          </Text>
        </button>
      </div>
    )

    if (isXS) {
      return (
        <div className={[_s.d, _s.z4, _s.minH53PX, _s.w100PC, _s.mtAuto, _s.bgPrimary].join(' ')}>
          <div className={[_s.d, _s.minH53PX, _s.bgPrimary, _s.aiCenter, _s.z3, _s.bottom0, _s.right0, _s.left0, _s.posFixed].join(' ')}>
            <div className={[_s.d, _s.w100PC, _s.saveAreaInsetPB, _s.saveAreaInsetPL, _s.saveAreaInsetPR].join(' ')}>
              <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.minH53PX, _s.w100PC, _s.borderTop1PX, _s.borderColorSecondary].join(' ')}>
                {btns}
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className={[_s.d, _s.posAbs, _s.bottom0, _s.left0, _s.right0, _s.flexRow, _s.aiCenter, _s.minH58PX, _s.bgPrimary, _s.w100PC, _s.borderTop1PX, _s.borderColorSecondary].join(' ')}>
        {btns}
      </div>
    )
  }

}

ChatConversationRequestApproveBar.propTypes = {
  chatConversationId: PropTypes.string,
  onApproveChatConversationRequest: PropTypes.func.isRequired,
}

export default withRouter(connect()(ChatConversationRequestApproveBar))